import { Container, Image } from 'react-bootstrap';

function App() {
    return (
      <Container>
        <div className="welcome-center">
            <div className="welcome-inner">
                <Image src='crane_sm.png' className='' />
                <h5 className='notification'><br/><br/>Sorry. Nothing found</h5>
            </div>
        </div>
      </Container>
    );
  }

  export default App;
